// Playback URL helper for cloud-hosted samples. The public R2 bucket
// is bound to VITE_R2_PUBLIC_URL (e.g. https://samples.yourapp.dev);
// we just concatenate the r2_key on the end.
//
// This is intentionally a pure function — no fetch, no decode. The
// caller passes the URL to <audio>, AudioBuffer.decodeAudioData, or
// the Strudel `samples({…})` loader, same as any static URL.

import { getR2PublicUrl } from './env';

export function cloudSampleUrl(r2Key: string): string | null {
  const base = getR2PublicUrl();
  if (!base) return null;
  // Strip trailing slash on base and leading slash on key so the
  // concat is always correct regardless of how the env var's written.
  return base.replace(/\/$/, '') + '/' + r2Key.replace(/^\//, '');
}
